import { Module } from 'wrapper6'
import { debounce } from '../utils/_debounce'

const $ = jQuery

export default class ScrollToTop extends Module {
  ready (app) {
    this.btn = $('#scroll-to-top')

    if (this.btn) {
      this.showBtnIfScrolled()
      this.scrollToTop()
    }
  }

  showBtnIfScrolled () {
    this.toggleClass()

    window.addEventListener('scroll', debounce(() => {
      this.toggleClass()
    }, 200))
  }

  scrollToTop () {
    this.btn.on('click', () => {
      $('html, body').animate({ scrollTop: 0 }, 'slow')
      return false
    })
  }

  toggleClass () {
    if (window.pageYOffset > 200) {
      this.btn.addClass('show')
    } else {
      this.btn.removeClass('show')
    }
  }
}
